export default defineAppConfig({
  ui: {
    colors: {
      primary: 'blue',
      neutral: 'coolGray'
    },

    button: {
      variants: {
        size: { sm: { base: 'text-sm' } }
      }
    },

    card: {
      slots: {
        root: 'dark:bg-brand-900'
      }
    },

    drawer: {
      slots: {
        container: 'p-5 pb-10',
        overlay: 'dark:bg-black/50',
        content: 'dark:bg-brand-900'
      }
    },

    modal: {
      slots: {
        overlay: 'dark:bg-black/50',
        content: 'dark:bg-brand-900'
      }
    },

    popover: {
      slots: { content: 'dark:bg-brand-900' }
    },

    tooltip: {
      slots: {
        text: 'whitespace-normal',
        content:
          'dark:bg-neutral-900 [@media(pointer:coarse)]:hidden px-2 py-1 text-xs h-auto font-normal relative overflow-auto text-wrap w-full max-w-xs'
      }
    },

    tabs: {
      slots: {
        list: 'p-0'
      },
      variants: {
        size: {
          md: {
            trigger: 'py-2',
            indicator: 'translate-y-1'
          }
        },
        variant: {
          pill: {
            list: 'bg-transparent rounded-none',
            trigger: 'data-[state=active]:dark:text-primary-500',
            indicator:
              'dark:bg-transparent border-b border-primary-500 rounded-none'
          },
          duration: {
            list: 'bg-[#32353A]',
            indicator: 'bg-[#0B0E12] border-none',
            trigger: 'text-[#E0E2E8] data-[state=active]:text-[#E0E2E8]'
          }
        }
      },
      compoundVariants: [
        {
          size: 'xs',
          variant: 'duration',
          orientation: 'horizontal',
          class: {
            list: 'p-0.5 rounded-sm',
            indicator: 'inset-y-0.5 rounded-sm',
            trigger: 'text-2xs'
          }
        }
      ]
    },

    selectMenu: {
      slots: {
        group: 'cursor-pointer',
        content: 'z-50 bg-brand-900 cursor-pointer',
        item: '!items-center hover:bg-brand-800 rounded-sm',
        trailingIcon:
          'group-data-[state=open]:rotate-180 transition-transform duration-200'
      },
      variants: {
        variant: {
          outline:
            'dark:bg-brand-900 shadow-xs dark:text-white ring-1 ring-inset dark:ring-neutral-700'
        },
        size: {
          md: {
            itemTrailingIcon: 'size-4'
          }
        }
      }
    },

    skeleton: {
      base: 'dark:bg-brand-800'
    },

    table: {
      slots: {
        tr: 'border-0',
        loading: 'py-0',
        root: 'h-full overflow-auto',
        td: 'p-2 text-xs dark:text-neutral-50',
        thead: 'dark:bg-brand-900 sticky top-0 z-[1]',
        empty: 'dark:text-neutral-500 capitalize text-xs py-10',
        th: 'p-4 text-xs font-medium whitespace-nowrap bg-brand-925 dark:text-neutral-200'
      },
      variants: {
        loading: { true: { thead: 'after:hidden' } }
      }
    }
  }
})
